// Shared so SideMenuTemplate and the view itself can't drift on rename.
// SideMenuTemplate cannot import from CampanionStaffAccessView directly
// (PageTemplate -> PrimaryNavigation -> SideMenuTemplate creates a cycle),
// so this constant lives in its own module that both can pull in.
export const CONFIGCAT_FLAG_KEY = 'enable-campanion-staff-access-panel'
